export default "__VITE_ASSET__w49EQJN2ZYUV2EUOJMB1ug__"